import { AuthStore } from '@store';

export interface BaseApiPicker<T> {
  instance: () => T;
}

export abstract class BaseApiPickerImpl<T> implements BaseApiPicker<T> {
  constructor(protected authStore: AuthStore, protected realApi: T, protected mockApi: T) {}

  instance(): T {
    return this.authStore.isDemoSync ? this.mockApi : this.realApi;
  }
}
